import axios from "axios";

export default axios.create({
    baseURL: "https://us-central1-gestiondoc-68f0b.cloudfunctions.net/app/api", //https://app.ecoraapp.com:8094
    headers: {
        "Content-type": "application/json"
    }
});